import { FC, useContext, useState, type JSX } from "react";
import styles from "./CorporateActionsStockSplits.module.scss";
import Module from "@/components/module/Module";
import { getCorporateStockSplits } from "@/controllers/stock-corporate-actions";
import { Stock } from "@/models/stock";
import { MemoizedDataGrid } from "../data-grid/DataGrid";
import { ModuleContext } from "@/lib/Context";

interface PropsTypes {
    stock: Stock;
}

const CorporateActionsStockSplits: FC<PropsTypes> = ({ stock }) => {
    const { obfuscated } = useContext(ModuleContext);

    const [corpActionsFilters, setCorpActionsFilters] = useState<JSX.Element>(null);

    return (
        <div className={styles.StockCorporateActions}>
            <div className={styles.content}>
                <Module obfuscated={obfuscated} title="Stock Splits" help={{ moduleId: "stock_splits", modulePage: "V2_stock_splits" }} filters={corpActionsFilters} allowFullscreen feedback>
                    <MemoizedDataGrid fetcher={getCorporateStockSplits} data={{ tradingitem_id: stock.tradingitem_id }} id={stock.stock_id} setFilters={setCorpActionsFilters} />
                </Module>
            </div>
        </div>
    );
};

export default CorporateActionsStockSplits;
